import { createContext, useContext, useMemo, useRef } from "react";
import { Toast } from "primereact/toast";

const ToastContext = createContext(null);

const DEFAULT_LIFE = 2200;

export const ToastProvider = ({ children, position = "top-right" }) => {
  const toastRef = useRef(null);

  const api = useMemo(
    () => ({
      showToast: (options = {}) => {
        toastRef.current?.show({ life: DEFAULT_LIFE, ...options });
      },
      showSuccess: (summary = "Success", detail = "", life = DEFAULT_LIFE) => {
        toastRef.current?.show({ severity: "success", summary, detail, life });
      },
      showError: (summary = "Error", detail = "", life = 3000) => {
        toastRef.current?.show({ severity: "error", summary, detail, life });
      },
      showInfo: (summary = "Info", detail = "", life = DEFAULT_LIFE) => {
        toastRef.current?.show({ severity: "info", summary, detail, life });
      },
      showWarn: (summary = "Warning", detail = "", life = 2500) => {
        toastRef.current?.show({ severity: "warn", summary, detail, life });
      },
    }),
    []
  );

  return (
    <ToastContext.Provider value={api}>
      {children}
      <Toast ref={toastRef} position={position} />
    </ToastContext.Provider>
  );
};

export const useToast = () => {
  const context = useContext(ToastContext);
  if (!context) {
    throw new Error("useToast must be used within a ToastProvider");
  }
  return context;
};
